import React, { useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useHeaderLinks } from 'providers/AreasProvider';
import { useTranslation } from 'react-i18next';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { IconButton } from '@totalsoft/rocket-ui';

const LogDetailHeader = () => {
  const history = useHistory();
  const [, setHeaderLinks] = useHeaderLinks();
  const { t } = useTranslation();

  const handleBackToListClick = useCallback(() => {
    history.push('/logs');
  }, [history]);

  useEffect(() => {
    setHeaderLinks(
      <IconButton onClick={handleBackToListClick} color='primary' variant='text' tooltip={t('Tooltips.BackToList')}>
        <ArrowBack />
      </IconButton>
    );
  }, [setHeaderLinks, handleBackToListClick, t]);

  return <></>;
};

export default LogDetailHeader;
